<template>
  <div class="content-page">
    <div class="page-title flex-center-start">
      <img :src="backUrl" alt="" @click="back">
      {{ $t('pageTitle.about') }}
    </div>
    
    <div class="about-content">
      <div class="about-section">
        <h2>About {{ appName }}</h2>
        <p>{{ appName }} is a leading global digital asset exchange, providing users with secure, professional, and innovative cryptocurrency trading services.</p>
      </div>
      
      <div class="about-section">
        <h2>Our Mission</h2>
        <p>To empower individuals by providing accessible, secure, and transparent financial tools through blockchain technology.</p>
      </div>
      
      <div class="about-section">
        <h2>Our Vision</h2>
        <p>To become the most trusted digital asset platform, bridging traditional finance with the future of blockchain technology.</p>
      </div>
      
      <div class="about-section">
        <h2>Core Values</h2>
        <ul>
          <li><strong>Security First:</strong> We prioritize the safety of our users' assets and data above all else.</li>
          <li><strong>Innovation:</strong> We continuously strive to improve our technology and offerings.</li>
          <li><strong>Transparency:</strong> We maintain open communication with our users and the community.</li>
          <li><strong>User-Centered:</strong> We design our products and services with users' needs in mind.</li>
        </ul>
      </div>
      
      <div class="about-section" v-show="false">
        <h2>Contact Us</h2>
        <p>Email: support@{{ currentDomain }}</p>
        <p>Follow us on social media for the latest updates.</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      backUrl: require('../../assets/imgs/icon-back.png'),
    }
  },
  computed: {
    appName() {
      return this.$store.state.appName
    },
    currentDomain() {
      return window.location.hostname
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    toPath(path) {
      if (path) {
        this.$router.push({
          name: path
        })
      }
    },
    toRefresh() {
      this.$toast.success(this.i18n.t('about.label3'))
    }
  }
}
</script>
<style scoped>
.about-content {
  padding: 20px;
  color: #333;
}

.about-section {
  margin-bottom: 30px;
}

.about-section h2 {
  font-size: 18px;
  margin-bottom: 15px;
  color: #0d47a1;
  font-weight: 600;
}

.about-section p {
  line-height: 1.6;
  margin-bottom: 10px;
}

.about-section ul {
  padding-left: 20px;
}

.about-section li {
  margin-bottom: 8px;
  line-height: 1.5;
}
</style>